<script setup>
import { computed } from "vue";

const props = defineProps({
    purchaseOption: {
        type: Object,
        required: true,
    },
    paymentStatus: {
        type: String,
        default: "",
        required: true,
    },
});

// Computed

const getTags = computed(() => {
    const tags = props.purchaseOption.statusTags;

    if (
        props.paymentStatus === "Unpaid" &&
        !tags.find((tag) => tag.id === "unpaid")
    ) {
        tags.push({
            id: "unpaid",
            name: "Unpaid",
            color: "soli-status-red",
        });
    }

    return tags;
});
</script>

<template>
    <v-list-item class="lesson-detail-purchase-option gap-4">
        <v-list-item-avatar>
            <v-icon>local_mall</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="soli-grey">
            <v-list-item-subtitle>Purchase Option</v-list-item-subtitle>
            <v-list-item-title class="mb-1">
                {{
                    purchaseOption ? `${purchaseOption.name}` : `${event.type}`
                }}
            </v-list-item-title>
            <div class="flex gap-1 align-center flex-wrap mb-05">
                <v-chip
                    v-for="tag in getTags"
                    :key="tag.id"
                    x-small
                    :color="tag.color"
                    class="white--text font-weight-bold text-capitalize"
                    >{{ tag.name }}</v-chip
                >
            </div>
        </v-list-item-content>
    </v-list-item>
</template>
